"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.KitchenAmenitiesDto = void 0;
var class_validator_1 = require("class-validator");
var KitchenAmenitiesDto = (function () {
    function KitchenAmenitiesDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "available");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['KITCHEN', 'KITCHENETTE', 'SHARED_KITCHEN', 'SHARED_COMMUNAL_KITCHEN']),
        __metadata("design:type", String)
    ], KitchenAmenitiesDto.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "cookwareDishwareUtensils");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "dishwasher");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "refrigerator");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['REFRIGERATOR', 'FULL_SIZED_REFRIGERATOR_FREEZER', 'REFRIGERATOR_ON_REQUEST']),
        __metadata("design:type", String)
    ], KitchenAmenitiesDto.prototype, "refrigeratorType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "oven");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "microwave");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['MICROWAVE', 'MICROWAVE_ON_REQUEST']),
        __metadata("design:type", String)
    ], KitchenAmenitiesDto.prototype, "microwaveType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "riceCooker");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "stovetop");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], KitchenAmenitiesDto.prototype, "minibar");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['MINIBAR', 'MINIBAR_STOCKED_FREE', 'MINIBAR_STOCKED_FREE_CHARGED']),
        __metadata("design:type", String)
    ], KitchenAmenitiesDto.prototype, "minibarType");
    return KitchenAmenitiesDto;
}());
exports.KitchenAmenitiesDto = KitchenAmenitiesDto;
//# sourceMappingURL=kitchen-amenities.dto.js.map